const FILTERS_CACHE_KEY = 'Drift.Conversation.queryFilters'
const INBOX_CACHE_KEY = 'Drift.Conversation.inboxId'

export const setFilters = filters => {
  if (!filters) {
    return
  }
  if (!localStorage) {
    console.warn('localStorage is not available')
    return
  }

  localStorage.setItem(FILTERS_CACHE_KEY, JSON.stringify(filters))
  return filters
}

export const clearFilters = () => {
  if (!localStorage) {
    console.warn('localStorage is not available')
    return
  }

  localStorage.removeItem(FILTERS_CACHE_KEY)
}

export const getFilters = () => {
  if (!localStorage) {
    console.warn('localStorage is not available')
    return
  }

  const filters = localStorage.getItem(FILTERS_CACHE_KEY)
  return filters && JSON.parse(filters)
}

export const setInboxId = (inboxId) => {
  if (!localStorage) {
    console.warn('localStorage is not available')
    return
  }

  localStorage.setItem(INBOX_CACHE_KEY, inboxId)
  return inboxId
}

export const clearInboxId = () => {
  if (!localStorage) {
    console.warn('localStorage is not available')
    return
  }

  localStorage.removeItem(INBOX_CACHE_KEY)
}

export const getInboxId = () => {
  if (!localStorage) {
    console.warn('localStorage is not available')
    return
  }

  return localStorage.getItem(INBOX_CACHE_KEY)
}

export const clearAll = () => {
  if (!localStorage) {
    console.warn('localStorage is not available')
    return
  }

  localStorage.removeItem(INBOX_CACHE_KEY)
  localStorage.removeItem(FILTERS_CACHE_KEY)
}


// WEBPACK FOOTER //
// ./src/scripts/app/cache/filters.js